import React from 'react' 

const Videos = () => {
    return (
        <div className="container-1">
            <br/>
            <br/>
            <br/>
            <br/>
            <h1 className="center">My Videos 📹</h1>
            <br/>
            <div className="recent-video-videos">
                <iframe className="bitlyvideopreview"  src="https://www.youtube.com/embed/Vfck2ivMA5E" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <br/>
                <br/>
                <a
                className="general-button"
                href="https://www.youtube.com/c/SkylerBasco"
                target="_blank"
                rel="noopener noreferrer"
            >
                See more on my channel!
            </a>
            </div>
            <br/>
            
            <br/>
            <br/>
            <h1 className="center">Why YouTube? ▶️</h1>
            
            <p className="videos-ptext">
            My life has always revolved around watching YouTube videos. 
            <br/>
            <br/>
            Joey Graceffa was the 1st YouTuber I’d watch regularly. From vlogs to Minecraft, he shaped my love for video games and helped me find my voice.
            <br/>
            <br/>
            At 13, I met him at ComicCon 2016. It was one of the best days ever.
            </p>

            <div className = "skylerjoeypic" text-align="center">
            <img className ="skylerjoeypicdimensions" text-align="center" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/image%2039.png"></img>
            <h6 className="videos-h6text">Above: 13-year-old me meeting Joey Graceffa and giving him a piece of fan art I made.</h6>

            </div>

            <br/>
            <br/>
            <h1 className="center">How I started 🏁</h1>

            <p className="videos-ptext">

            Before college, I binge-watched “day in the life” videos from tech YouTubers, ranging from software engineers to UX designers.
            <br/>
            <br/>
            While doing my 1st SWE Internship, I thought, <i>'What if I shared my experiences too?'</i>
            <br/>
            <br/>
            So I posted my first video, and now I’m vlogging my journey as I navigate through tech and help others find their voice in it along the way.
            </p>
            <br/>
            <h1 className="center">Let's gooo! 🔥</h1>
            <p className="videos-ptext">

            Join me in my journey as a chaotic coder, designer, CS student, & more!
            </p>
            <div className="center">
            
            <a
                className="general-button"
                href="https://www.youtube.com/c/SkylerBasco"
                target="_blank"
                rel="noopener noreferrer"
            >
                Subscribe to my channel!
            </a>
            </div>
            <p className="videos-ptext">
            P.S. Joey Graceffa, I hope to meet you again one day to thank you for inspiring me to break out of my comfort zone – both through this YouTube channel and in life as a whole.
            </p>
            <br/>
            <h1 className="center">Biz Inquiries 📨</h1>
            <p className="videos-ptext">
            For any social media sponsorship, collaboration, or business inquiries, feel free to email me at <a href="mailto:theskylerbasco@gmail.com?subject = Feedback&body = Message" className="revuelinks">theskylerbasco@gmail.com</a>! Happy to chat.
            </p>

        </div>
    )
}

export default Videos